import { useEffect } from 'react';

/**
 * Every form of the app answers a refused submit the same way (lib/formFeedback.ts: one shake, the focus on the first
 * invalid field). Mounted once by Root; the code is fetched right after the first paint, in its own chunk, so the first
 * page load does not carry it (every form is on a page that loads after it). Without that chunk (offline), forms
 * simply do not shake.
 */
export function useFormFeedback() {
  useEffect(() => {
    let live = true;
    let stop: (() => void) | undefined;
    import('@lib/formFeedback').then(
      (m) => {
        if (live) stop = m.watchRefusedSubmits();
      },
      () => undefined,
    );
    return () => {
      live = false;
      stop?.();
    };
  }, []);
}
